import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TranslateArticleState {
  isTranslated: boolean;
  hasTranslationData: boolean;
}

const initialState: TranslateArticleState = {
  isTranslated: false, // for tracking if currently showing translated text
  hasTranslationData: false // to prevent redundant API calls
};

const translateArticleSlice = createSlice({
  name: 'translateArticle',
  initialState,
  reducers: {
    setIsTranslated: (state, action: PayloadAction<boolean>) => {
      state.isTranslated = action.payload;
    },
    setHasTranslationData: (state, action: PayloadAction<boolean>) => {
      state.hasTranslationData = action.payload;
    },
    toggleIsTranslated: (state) => {
      if (state.hasTranslationData) {
        state.isTranslated = !state.isTranslated;
      }
    },
    resetTranslation: (state) => {
      state.isTranslated = false;
      state.hasTranslationData = false;
    }
  }
});

export const {
  setIsTranslated,
  setHasTranslationData,
  toggleIsTranslated,
  resetTranslation
} = translateArticleSlice.actions;

export default translateArticleSlice.reducer;
